import { Body } from '@assembly-js/design-system';
import classNames from 'classnames';
import React from 'react';

import { NotificationBadge } from 'src/components/NotificationBadge';
import { useEnableNewSidebar } from 'src/hooks/useEnableNewSidebar';
import { formatNotificationCount } from 'src/utils/NotificationsUtils';

interface SidebarNotificationBadgeProps {
  content?: number;
  label?: string;
  showZero?: boolean;
  backgroundColor: string;
  textColor: string;
  htmlId?: string;
}

const SidebarNotificationBadgeComponent: React.FC<
  SidebarNotificationBadgeProps
> = ({
  content = 0,
  label,
  showZero = false,
  backgroundColor,
  textColor,
  htmlId,
}) => {
  const enableNewSidebar = useEnableNewSidebar();

  if (!enableNewSidebar) {
    return (
      <NotificationBadge
        isSidebar
        content={content}
        showZero={showZero}
        backgroundColor={backgroundColor}
        textColor={textColor}
        htmlId={htmlId}
      />
    );
  }

  if (!label && content < 1 && !showZero) {
    return null;
  }

  return (
    <span
      data-testid={htmlId}
      className={classNames(
        'flex items-center justify-center shrink-0 box-border bg-gray-200 text-primary',
        !label && content >= 10 ? 'px-0.5' : 'px-2',
        'py-[2px] rounded-[4px] min-w-[22px]',
      )}
      style={{ backgroundColor, color: textColor }}
    >
      <Body
        size="xs"
        tag="span"
        className="text-center whitespace-nowrap text-current"
      >
        {label ?? formatNotificationCount(content)}
      </Body>
    </span>
  );
};

export const SidebarNotificationBadge = React.memo(
  SidebarNotificationBadgeComponent,
);
SidebarNotificationBadge.displayName = 'SidebarNotificationBadge';
